/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {AutoLoginCapability} from "../model/auto-login-capability";
import {Device} from "../model/device";
import {DeviceActivityType} from "../model/device-activity-type";
import {DeviceSettings} from "../model/device-settings";
import {IDeviceCapability} from "../model/i-device-capability";
import {ListData} from "../model/list-data";
import {SearchParamRequest} from "../model/search-param-request";
/**
 * Device Controller for handling device related operations.
 */ 

@Injectable({
    providedIn: "root",
})
export class SimDeviceService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
/**
 * Add a device capability to a device.
 */ 

    public addDeviceCapability(capability: IDeviceCapability) {
        return super.post<Device>(`/api/Device/AddDeviceCapability`, capability);
    }
/**
 * Checks if Device exits for given Device Id
 */ 

    public checkIfDeviceIdExists(deviceId: string) {
        return super.get<Device>(`/api/Device/CheckIfDeviceIdExists`, {deviceId: deviceId});
    }
/**
 * Delete Device
 */ 

    public deleteDevice(deviceId: string) {
        return super.get<boolean>(`/api/Device/DeleteDevice`, {deviceId: deviceId});
    }
/**
 * Get filtered devices.
 */ 

    public getFilteredDevices(searchParameters: SearchParamRequest) {
        return super.get<ListData<Device>>(`/api/Device/GetFilteredDevices`, {searchParameters: searchParameters}, ["searchParameters"]);
    }
/**
 * Should be called after registering the device. Will trigger an SignalR event to the device with the DeviceState object.
 */ 

    public readyToCommunicate(deviceActivityType: DeviceActivityType) {
        return super.get<void>(`/api/Device/ReadyToCommunicate/${encodeURIComponent(deviceActivityType)}`, );
    }
/**
 * Registers a device that came online. If the device provides a client ID in the header the device object will be returned. Otherwise, a new client ID will be generated and a new device object will be returned.
 */ 

    public registerDevice() {
        return super.get<Device>(`/api/Device/RegisterDevice`, );
    }
/**
 * Sets the auto login capability of a device. Each device has a maximum of one auto login capability.
 */ 

    public setDeviceAutoLoginCapability(autoLoginCapability: AutoLoginCapability, deviceId: string) {
        return super.post<Device>(`/api/Device/SetDeviceAutoLoginCapability/${encodeURIComponent(deviceId)}`, autoLoginCapability);
    }
/**
 * Test endpoint to get device settings for a specific device ID.
 */ 

    public testGetDeviceSettingsForId(deviceId: string) {
        return super.get<DeviceSettings>(`/api/Device/TestGetDeviceSettingsForId/deviceSettings/${encodeURIComponent(deviceId)}`, );
    }
/**
 * Update the device default language.
 */ 

    public updateDeviceLanguage(language: string, deviceId: string = null) {
        return super.get<void>(`/api/Device/UpdateDeviceLanguage`, {language: language, deviceId: deviceId});
    }
}